import React, { useMemo } from 'react';
import { analyticsSnapshot } from '../../data/analyticsSnapshot';
import MetricSummary from '../common/MetricSummary';
import { findLatestValue } from '../../utils/dataHelpers';
import ChartCard from '../common/ChartCard';
import { ChartData } from 'chart.js';

const WebEventsPage: React.FC = () => {
  const events = analyticsSnapshot.webAnalytics.events;
  const latestOrganic = findLatestValue(events.datasets[0].data);
  const latestPaid = findLatestValue(events.datasets[1].data);
  const label = latestOrganic.index >= 0 ? events.labels[latestOrganic.index] : 'Veri yok';
  const insights = analyticsSnapshot.aiAnalysis.webAnalytics.events.insights;

  const chartData = useMemo<ChartData<'bar'>>(
    () => ({
      labels: Array.from(events.labels),
      datasets: [
        {
          label: 'Organik Dönüşüm',
          data: Array.from(events.datasets[0].data)
        },
        {
          label: 'Ücretli Dönüşüm',
          data: Array.from(events.datasets[1].data)
        }
      ]
    }),
    [events.labels, events.datasets]
  );

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Etkinlik ve Dönüşüm Olayları</h1>
          <p className="text-white/70 mt-2">
            Organik ve ücretli arama üzerinden tetiklenen dönüşüm olaylarını takip edin.
          </p>
        </div>
        <div className="text-sm text-white/40">
          Son veri: <span className="text-white/70">{label}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MetricSummary
          title="Organik Etkinlik Dönüşümleri"
          value={latestOrganic.value}
          description="Organik arama kaynaklı dönüşümler."
        />
        <MetricSummary
          title="Ücretli Etkinlik Dönüşümleri"
          value={latestPaid.value}
          description="Ücretli arama kaynaklı dönüşümler."
        />
      </div>

      <ChartCard
        title="Aylık Etkinlik Dönüşüm Trendleri"
        description="Organik ve ücretli kaynaklı dönüşüm olaylarının karşılaştırması."
        chartType="bar"
        data={chartData}
        insights={insights}
      />

    </div>
  );
};

export default WebEventsPage;

